import React from "react";
import { logo } from "../../assets/index";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
const Footer = () => {
  return (
    <div className="w-full py-20 h-auto border-b-[1px] border-black
     grid grid-cols1 md:grid-cols-2 lgl:grid-cols-4 gap-8 ">
      {/* logo*/}
      <div className="w-full h-full flex flex-col gap-8">
        <div className=" flex items-center  ">
          <img src={logo} alt="logo" />
          <p className="mt-2">MG-ZUZU</p>
        </div>
        {/* Icons*/}
        <div className=" flex gap-4">
          <span className="bannerIcon">
            <a href="https://m.facebook.com/people/Macheda-Graphics/100083311030390/">
              <FaFacebook />
            </a>
          </span>
          <span className="bannerIcon">
            <FaInstagram />
          </span>
          <span className="bannerIcon">
            <FaTwitter />
          </span>
          <span className="bannerIcon">
            <FaLinkedin />
          </span>
        </div>
      </div>
      {/*   Second div */}
      <div className="w-full h-full ">
       <h3 className="text-xl uppercase text-designColor tracking-wider">
       Partners
       </h3>
        <ul className="flex flex-col gap-4 font-titleFont font-medium overflow-hidden y-6">
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">Macheda Graphics <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">EBH Autoparts <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">ZuzuTech <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">SkyLabs360 <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
        </ul>
      </div>
      {/* Third div */}
      <div className="w-full h-full ">
       <h3 className="text-xl uppercase text-designColor tracking-wider">
      Services
       </h3>
        <ul className="flex flex-col gap-4 font-titleFont font-medium overflow-hidden y-6">
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">Network Design & Management <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">Network Security <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">Web & Mobile App Development <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">Desktop App Development <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">Graphic Design <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
        </ul>
      </div>
      {/* Fourth div */}
      <div className="w-full h-full ">
       <h3 className="text-xl uppercase text-designColor tracking-wider">
       Finished Projects
       </h3>
        <ul className="flex flex-col gap-4 font-titleFont font-medium overflow-hidden y-6">
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">Macheda Graphics Website <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">EBH Autoparts Website <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">ZuzuDiary Mobile App <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">MG-ZUZU portfolio  Website <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
         <li>
         <span className="w-full text-lg hover:text-designColor duration-300 cursor-pointer
            relative group">Firewall Bypassing in Windows Pcs <span className="absolute
            h-[1px] w-full inline-flex bg-designColor -bottom-1 left-0
            -translate-x-[100%] group-hover:translate-x-0 transition-transform
             duration-300"></span>
            </span>
         </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
